import React, { useEffect, useState } from 'react';
import LoginForm from './LoginForm';
import * as loginClient from '../../utils/loginClient';
import { Utils, LocalTheme } from 'ecrion-components';
import {
  makeStyles,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Chip,
} from "@material-ui/core";
import mhcLogo from "../../logo.svg";
const useStyles = makeStyles((theme) => ({
  media: {
    width: "100%",
    marginLeft: "-8px",
  },
}));


const SignIn = (props) => {
  const [hasSSO, setHasSSO] = useState();
  const classes = useStyles();
  const searchParams = Utils.url.getSearchParams(props.location.search);
const customTheme = {
  common: {
    Page: {
      /** Navigation bar on the top of the screen. */
      Common: {
        style: {
          backgroundColor: "#E0E5EB",
        },
      },
    },
  },
  overrides:{
  MuiPaper: {
    root: {
      backgroundColor: '#FFFFFF',
    },
  },
  MuiButton: {
    root: {
      minWidth: 120,
      borderRadius: "6px",
      padding: '4px 16px',
    },
    outlined: {
      padding: '4px 16px',
    },
    contained: {
      padding: '4px 16px',
    },
  },
  MuiIcon: {
    root: {
      fontSize: "0.75em",
    },
  },
  MuiAvatar: {
    root: {
      height: "32px",
      width: "32px",
    },
  },
  MuiCardContent: {
    root: {
      paddingLeft: "46px",
      paddingRight: "46px",
    },
  },
  MuiCardHeader: {
    root: {
      paddingLeft: "46px",
      paddingRight: "46px",
    },
  },
  MuiCard: {
    root: {
      minWidth: "500px",
      borderRadius: "8px",
      border: "0.25pt solid #627383",
    },
  },
  MuiGrid: {
    root: {
      padding: "0px",
    },
  },
  MuiChip: {
    root: {
      justifyContent: "space-between",
      width: "100%",
    },
  },
  MuiListItemText: {
    root: {
      padding: "0px 4px",
    },
  },
  MuiMenuItem: {
    root: {
      padding: "0px 0px",
    },
  },
  MuiDivider: {
    root: {
      marginTop: "0px",
    },
  }
},
props: {
  MuiFormControl: {
    variant: "filled",
  },
  MuiInputLabel: {
    variant: "filled",
    shrink: false,
  },
  MuiTextField: {
    variant: "filled",
  },
  MuiButton: {
    color: "primary",
  },
}
}
  //TODO: implement no environment in URL

  useEffect(() => {
    if (!props.match.params.environment) {
      setHasSSO(false);
      return;
    }

    loginClient
      .getLoginInfo({
        environment: props.match.params.environment,
        userName: searchParams.userName,
      })
      .then((loginInfo) => {
        if (loginInfo) {
          setHasSSO(true);
          window.location.href = loginInfo.url;
        } else {
          setHasSSO(false);
        }
      })
      .catch(() => {
        setHasSSO(false);
      });
  }, []);

  if (hasSSO === undefined) return null;

  return  <LocalTheme theme={customTheme}><div>{!hasSSO && 
    <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          style={{ minHeight: "calc(100vh - 37px)" }}
        >
          <Grid item xs={12} sm={9} md={6} lg={3}>
  <Card>
  
                <CardHeader
                    titleTypographyProps={{ variant: "h4" }}
                    title={"Welcome to Portal!"}
                    style={{ textAlign: 'center'}}
                  />
                  <CardHeader
                    titleTypographyProps={{ variant: "subtitle2" }}
                    title={"Please enter your credentials below to get started"}
                    style={{ textAlign: 'center', paddingTop: 0 }}
                  />
      <CardContent><LoginForm {...props} />
      </CardContent>
      </Card>
      </Grid>
      </Grid>}</div></LocalTheme>;
};

export default SignIn;
